'use strict';

const $ = require('jquery');
const $forms = $('.js-disable-onsubmit');

$forms.one('submit', function() {
	$(this).on('submit', e =>
		e.preventDefault());
});